<header class="aow-top-nav">
    <div class="aow-top-nav__client" *ngIf="clientId && companyName"
         [class.is-clickable]="!isUniqueClient"
         (click)="redirectSelectClient()">
        <span class="client-name">{{ companyName }}</span>
        <mat-icon class="client-arrow" *ngIf="!isUniqueClient">keyboard_arrow_down</mat-icon>
    </div>

    <div class="aow-top-nav__actions">
        <!-- Language selector (flag) -->
        <app-language-selector></app-language-selector>

        <!-- Dark mode toggle -->
        <button mat-icon-button class="aow-top-nav__icon-btn" (click)="toggleTheme()"
            [matTooltip]="isDarkMode ? 'Light Mode' : 'Dark Mode'">
            <mat-icon class="aow-top-nav__icon">
                {{ isDarkMode ? 'light_mode' : 'nightlight_round' }}
            </mat-icon>
        </button>

        <!-- Profile menu -->
        <app-profile-menu></app-profile-menu>
    </div>
</header>